import { Component, OnInit } from '@angular/core';
import { CauHinhNhanService } from '../../services';

@Component({
  selector: 'multi-dropdown',
  templateUrl: './multidropdown.component.html',
  styleUrls: ['./multidropdown.component.scss']
})
export class MultidropdownComponent implements OnInit {
  selectedList: any = [];
  isClickOpen = false;
  listLoaiCanhBao: any = [];
  constructor(private cauHinhNhanService: CauHinhNhanService) { }

  ngOnInit() {
    this.cauHinhNhanService.getAll_LoaiCanhBao().subscribe(
      res => {
        this.listLoaiCanhBao = JSON.parse(res).data;
      }
    );
    // this.selectedList = [
    //   {
    //     macanhbao: "1",
    //     tencanhbao: "Cảnh báo vận hành"
    //   },
    //   {
    //     macanhbao: "2",
    //     tencanhbao: "Cảnh báo vận hành 1"
    //   },
    //   {
    //     macanhbao: "3",
    //     tencanhbao: "Cảnh báo vận hành 2"
    //   },
    //   {
    //     macanhbao: "4",
    //     tencanhbao: "Cảnh báo vận hành 3"
    //   },
    // ]
  }
  xoaCanhBao(macanhbao) {
    let index = this.selectedList.findIndex(item => item.maloai == macanhbao);
    this.selectedList.splice(index, 1);
  }

  selectLoaiLoi(macanhbao) {
    let index = this.listLoaiCanhBao.findIndex(item => item.maloai == macanhbao);
    this.selectedList.push(this.listLoaiCanhBao[index]);
  }

}



// WEBPACK FOOTER //
// /media/tranhien/34DCFEAFDCFE6B0E/SourceCode/AMISS4/AMISS4_PC1_LINUX/src/app/share/multidropdown/multidropdown.component.ts